// Use this module instead of filters

const TimeDate = {
  /**
   * @src https://stackoverflow.com/questions/1322732/convert-seconds-to-hh-mm-ss-with-javascript
   */
  hms: seconds => {
    return [3600, 60]
      .reduceRight(
        (p, b) => r => [Math.floor(r / b)].concat(p(r % b)),
        r => [r]
      )(seconds)
      .map(a => a.toString().padStart(2, '0'))
      .join(':')
  },

  readableDateTime: unixTimestamp => {
    if (!unixTimestamp) return ''

    const date = new Date(unixTimestamp) // .toLocaleDateString('en-US')

    const year = date.getFullYear()
    const month = ('0' + (date.getMonth() + 1)).slice(-2)
    const day = ('0' + (date.getDay() + 1)).slice(-2)

    const hour = ('0' + date.getHours()).slice(-2)
    const min = ('0' + date.getMinutes()).slice(-2)
    const sec = ('0' + date.getSeconds()).slice(-2)

    const readableDateTime = year + '-' + month + '-' + day + '_' + hour + min + sec

    return readableDateTime
  },

  createdAt2timeWithSeconds: (unixTimestamp, lang = 'de-AT') => {
    if (!unixTimestamp) return ''
    let time = new Date(unixTimestamp).toLocaleTimeString(lang)
    time = time.toString().slice(0, 8)
    return time
  },

  createdAt2time: (unixTimestamp, lang = 'de-AT') => {
    if (!unixTimestamp) return ''
    let time = new Date(unixTimestamp).toLocaleTimeString(lang)
    time = time.toString().slice(0, 5)
    return time
  },

  createdAt2date: (unixTimestamp, lang = 'de-AT') => {
    if (!unixTimestamp) return ''
    return new Date(unixTimestamp).toLocaleDateString('de-AT')
  },

  /**
   * Returns the difference of 2 unix timestamps in the format of a
   * digital time display: "00:00:00"
   *
   * @param {number} start The starttime
   * @param {number} end The endtime
   *
   * @returns integer
   */
  formattedDuration: (start, end) => {
    if (!start || !end) return ''

    const diff = Math.ceil((end - start) / 1000)
    const formattedDiff = TimeDate.hms(diff)

    return formattedDiff
  }
}

export { TimeDate }
